import { render, staticRenderFns } from "./redeemList.vue?vue&type=template&id=6f17ff8a&scoped=true"
import script from "./redeemList.vue?vue&type=script&lang=js"
export * from "./redeemList.vue?vue&type=script&lang=js"
import style0 from "./redeemList.vue?vue&type=style&index=0&id=6f17ff8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f17ff8a",
  null
  
)

export default component.exports